export default "__VITE_ASSET__D5Mk9bQH__"